import React from "react";
import NoProductsFound from "./NoProductsFound";
import { Product } from "../types/restaurant";
import { usePaymentTheme } from "../../respayment/hooks/usePaymentTheme";
import ProductGrid from "../ProductGrid";

interface ProductDisplaySectionProps {
  filteredProducts: Product[];
  selectedProducts: Product[];
  handleIncrement: (product: Product) => void;
  handleDecrement: (product: Product) => void;
}

const ProductDisplaySection: React.FC<ProductDisplaySectionProps> = ({
  filteredProducts,
  selectedProducts,
  handleIncrement,
  handleDecrement,
}) => {
  const { fontClass } = usePaymentTheme();

  return (
    <>
      {filteredProducts.length > 0 ? (
        <ProductGrid
          products={filteredProducts}
          selectedProducts={selectedProducts}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
        />
      ) : (
        <NoProductsFound fontClass={fontClass} />
      )}
    </>
  );
};

export default ProductDisplaySection;